export function UserOctagonGrey({ className = '' }: Readonly<{ className?: string }>) {
  return (
    <span className={`icon ${className}`}>
      <svg
        width="18"
        height="18"
        viewBox="0 0 18 18"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M14.63 4.3875L10.175 1.815C9.4475 1.395 8.5475 1.395 7.8125 1.815L3.365 4.3875C2.6375 4.8075 2.1875 5.5875 2.1875 6.435V11.565C2.1875 12.405 2.6375 13.185 3.365 13.6125L7.82 16.185C8.5475 16.605 9.4475 16.605 10.1825 16.185L14.6375 13.6125C15.365 13.1925 15.815 12.4125 15.815 11.565V6.435C15.8075 5.5875 15.3575 4.815 14.63 4.3875ZM8.9975 5.505C9.965 5.505 10.745 6.285 10.745 7.2525C10.745 8.22 9.965 9 8.9975 9C8.03 9 7.25 8.22 7.25 7.2525C7.25 6.2925 8.03 5.505 8.9975 5.505ZM11.0075 12.495H6.9875C6.38 12.495 6.0275 11.82 6.365 11.3175C6.875 10.56 7.865 10.05 8.9975 10.05C10.13 10.05 11.12 10.56 11.63 11.3175C11.9675 11.8125 11.6075 12.495 11.0075 12.495Z"
          fill="#6E707A"
        />
      </svg>
    </span>
  );
}
